/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from "react";
import {Link} from "react-router-dom";
import {showHeader} from "../constants/functions";
import {getJSON} from "../constants/network";
import routes from "../constants/routes";
import Vacio from "./Vacio";
import ListaEstados from "./ListaEstados";
import Mapa from "./Mapa";

export default class extends Component {
    constructor(props) {
        super(props);
        this.index = 0;
        this.state = {
            data: {data: []},
            estado_elegido: false
        };
        this.completo = this.props.completo !== false;
    }

    componentDidMount() {
        if (this.completo) {
            showHeader();
        }
        getJSON(routes.regionAll)
            .then(result => {
                let regiones = result.data;
                for (let i = 0; i < regiones.length; i++) {
                    if (this.props.match && regiones[i].slug === this.props.match.params.regionSlug) {
                        this.index = i;
                        break;
                    }
                }
                this.setState({data: result.data});
            });
    }

    componentDidUpdate() {
        if (this.completo) {
            showHeader();
        }
    }

    componentWillReceiveProps(nextProps) {
        let regiones = this.state.data;
        for (let i = 0; i < regiones.length; i++) {
            if (nextProps.match && regiones[i].slug === nextProps.match.params.regionSlug) {
                this.index = i;
                break;
            }
        }
    }

    render() {
        let data = this.state.data;
        let _this = this;

        if (data && data[this.index]) {
            let region = data[this.index];
            return (
                <div id="regiones">
                    <div className="rutas-title">
                        <h2>Nuestras Rutas</h2>
                        <div className="estrella">
                            <span className="glyphicon glyphicon-star"/>
                        </div>
                    </div>
                    <div className="row">
                        <ul className="regiones-list col-xs-12">
                            {
                                data.map(function (data) {
                                    let imagen = (data.imagen)?data.imagen.url:'http://placehold.it/150x100';
                                    return(
                                        <li className="col-xs-6 col-sm-3" key={data.id}>
                                            <Link to={`/region/${data.slug}`} className={`region_link ${data.slug}`} data-slug={data.slug}>
                                                <img src={imagen} alt={data.region}/>
                                                <h2 label={data.descripcion}>{data.region}</h2>
                                            </Link>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                    {
                        (function () {
                            if (_this.completo) {
                                return (
                                    <div className="row">
                                        <div id="container-estados-mapa" className="col-xs-12">
                                            <div id="estados-list" className={"col-sm-3 col-xs-12 " + region.slug}>
                                                <div className="box">
                                                    <h2 className="estado-title">Estados de {region.region}</h2>
                                                    <div className="estados-list">
                                                        <ListaEstados estados={region.estados}/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="container-mapa" className="col-sm-9 hidden-xs">
                                                <img src="/img/brujula_oficial.png" id="logo" alt=""/>
                                                <div id="nombre-estado" className={region.slug}/>
                                                <div className="box" id="mapa-resto"/>
                                                <div id="div-mapa">
                                                    <Mapa key="mapa"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        })()
                    }
                </div>
            )
        } else {
            return ( <Vacio/>)
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Regiones.js